import { useEffect } from "react";
import { Nfc } from "lucide-react";
import { useReaderLine } from "../../hooks/useReaderLine";

const pad = (n) => String(n).padStart(2, "0");

export const BenchScan = ({ onScan, active, existing, onReprogram, onSkip }) => {
  const { inputProps, keys, docFocus } = useReaderLine(onScan, { enabled: active, captureGlobal: active });
  useEffect(() => { if (active) inputProps.ref.current?.focus(); }, [active]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <section data-testid="bench-scan" className={`border p-6 transition-colors ${active ? "border-emerald-400/50 bg-emerald-400/5" : "border-slate-800 bg-slate-950/50"}`}>
      <div className="flex items-center justify-between gap-2">
        <p className="lab-label flex items-center gap-2 !text-emerald-300"><Nfc size={14} /> Step 1 // Scan</p>
        <span data-testid="bench-key-count" className="font-mono text-xs tracking-widest text-slate-500">KEYS RX: {keys}</span>
      </div>
      <h2 className="mt-2 font-display text-lg md:text-xl uppercase tracking-widest text-slate-50">
        {active ? "Place the next object on the reader" : "Reader paused while you edit"}
      </h2>
      <label className="mt-4 flex items-center gap-3 border-b border-emerald-400/40 pb-2 font-mono text-emerald-300">
        <span className="text-lg">&gt;</span>
        <input
          data-testid="bench-tag-input"
          {...inputProps}
          autoFocus={active}
          autoComplete="off"
          spellCheck={false}
          placeholder={!active ? "..." : docFocus ? "waiting for tag..." : "click here to listen"}
          className="w-full bg-transparent text-lg tracking-[0.2em] text-emerald-200 outline-none placeholder:text-slate-600"
        />
      </label>
      {existing && (
        <div data-testid="bench-duplicate" className="mt-4 flex flex-wrap items-center gap-3 border border-amber-400/40 bg-amber-400/5 p-3 font-mono text-sm text-amber-200">
          <span>Tag already programmed as <b>#{pad(existing.slot)} {existing.name}</b> ({existing.spore_word})</span>
          <button data-testid="bench-reprogram-button" onClick={onReprogram} className="lab-btn-ghost py-1">Reprogram</button>
          <button data-testid="bench-skip-button" onClick={onSkip} className="lab-btn-ghost py-1">Skip</button>
        </div>
      )}
    </section>
  );
};
